// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-t-6px[data-v-59a88f7c] {\n  margin-top: 6px;\n}", ""]);
// Exports
module.exports = exports;
